import React, { useState } from 'react';

import { Usuario, UsuarioPJ, Socios } from '../../pages/Cliente/Cadastro/Cadastro';
import CadastroPF from '../CadastroPF/CadastroPF';
import CadastroPJ from '../CadastroPJ/CadastroPJ';

interface CadastroDadosCadastraisProps {
    usuarioPF: Usuario,
    setUsuarioPF: React.Dispatch<React.SetStateAction<Usuario>>,
    setUsuarioPJ: React.Dispatch<React.SetStateAction<UsuarioPJ>>,
    socios: Socios[];
    setSocios: React.Dispatch<React.SetStateAction<Socios[]>>,
    setOpcaoSelecionada: React.Dispatch<React.SetStateAction<string>>,
}

export const CadastroDadosCadastrais = ({
    usuarioPF, setUsuarioPF, setUsuarioPJ, socios, setSocios, setOpcaoSelecionada
}: CadastroDadosCadastraisProps) => {
    const [mostrarCadastroPF, setMostrarCadastroPF] = useState<boolean>(false);
    const [mostrarCadastroPJ, setMostrarCadastroPJ] = useState<boolean>(false);

    const PF = () => {
        setMostrarCadastroPF(true);
        setMostrarCadastroPJ(false);
        setOpcaoSelecionada('PessoaFisica');
    };

    const PJ = () => {
        setMostrarCadastroPF(false);
        setMostrarCadastroPJ(true);
        setOpcaoSelecionada('PessoaJuridica');
    };
    return (
        <div className="Container">
            <div className="TextoTitulo">Cadastro de Cliente</div>

            <div className="Area_SelecaoServicoRadio">
                <input
                    type="radio"
                    name="tipoPessoa"
                    id="pessoaFisica"
                    value="PessoaFisica"
                    className="radio-hidden"
                    onClick={PF}
                />
                <label htmlFor="pessoaFisica" className={`radio-button ${mostrarCadastroPF ? 'selected' : ''}`}>
                    Pessoa Física
                </label>

                <input
                    type="radio"
                    name="tipoPessoa"
                    id="pessoaJuridica"
                    value="PessoaJuridica"
                    className="radio-hidden"
                    onClick={PJ}
                />
                <label htmlFor="pessoaJuridica" className={`radio-button ${mostrarCadastroPJ ? 'selected' : ''}`}>
                    Pessoa Jurídica
                </label>
            </div>

            {mostrarCadastroPF && <CadastroPF nacionalidade={usuarioPF.nacionalidade} setUsuarioPF={setUsuarioPF} />}
            {mostrarCadastroPJ && (
                <CadastroPJ setUsuarioPJ={setUsuarioPJ} socios={socios} setSocios={setSocios} />
            )}
        </div>
    );
};
